import moment from 'moment';
import {useState} from 'react';

import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';

import Box from '@mui/material/Box';

import '../scheduling/SelectADate.scss';
import CustomInputLabel from './CustomInputLabel';

const handleDatePick = ({setDate, onChange}) => momentObj => {
  setDate(momentObj);
  if (!momentObj) return;
  onChange({target: {value: momentObj.format('MM/DD/yyyy')}});
};

const DateField = props => {
  const [date, setDate] = useState(
    props.defaultValue
    ? moment(props.defaultValue)
    : null
  );
  const [focused, setFocus] = useState(false);
  const {onChange} = props;
  return (
    <>
      <CustomInputLabel required={props?.required || false}>
        {props.label}
      </CustomInputLabel>
      <Box className='custom-date-picker'>
        <SingleDatePicker
          id={props.id}
          date={date}
          onDateChange={handleDatePick({setDate, onChange})}
          focused={!!focused}
          onFocusChange={({focused}) => setFocus(focused)}
          numberOfMonths={1}
          hideKeyboardShortcutsPanel={true}
          noBorder={true}
          isOutsideRange={() => false}
          minDate={moment().subtract(2, 'years')}
          disabled={props.disabled || false}
        />
      </Box>
    </>
  );
};

export default DateField;